function t(t){return t?new Date(t).toJSON():void 0}export{t as default};
